
    import common from "@/util/common";
    import {useStore} from "@/store";
    import batterySystemInfo from './batterySystemInfo.vue';
    import batteryHealthy from './batteryHealthy.vue';
    // import checkItemBattery from './checkItemBattery/index.vue';
    // import checkPosition from './checkPosition.vue';
    import {defineComponent, ComputedRef, computed, reactive, watch, toRefs} from 'vue';

    interface State {
        showDescrip: boolean;
        tocOnlyShowFlaw: boolean;
        contRenderData: object;
        batterySystemInfoRenderData: object;
        checkItemBattery: object[];
        checkStandardRouter: string;
        batteryRank: string;
    }
    export default defineComponent({
        name: 'batteryDetectH5',
        props: {
        },
        setup(props: any) {
            let state: State = reactive({
                showDescrip: false,
                tocOnlyShowFlaw: false,
                contRenderData: {},
                batterySystemInfoRenderData: {},
                checkItemBattery:[],
                checkStandardRouter: '',
                batteryRank: ''
            }); 
            const {renderData} = toRefs(props);
            function getData(code, key='value', type='') {
                return common.getDataByCode( state.contRenderData, code, key, type)
            }
            let store = useStore();
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            watch(reportData, (data: any) => {
                const {checkModuleList, componentList} = JSON.parse(JSON.stringify(data));
                state.contRenderData = componentList.find(item => item.code === 'batteryDetect').configItems;
                const summary = componentList.find(item => item.code === 'summary').configItems;
                // state.batteryRank = summary && summary.find(item => item.code === 'batteryDetectLevel').value;
                state.batteryRank = common.getDataByCode(summary, 'soh', 'value', '');
                state.batterySystemInfoRenderData = getData('batterySystemInfo', 'items');
                for (let i=0; i< componentList.length; i ++) {
                    let item = componentList[i];
                    if (item.code === 'batterySafety' || item.code === 'batteryAppearance') {
                        state.checkItemBattery.push(item);
                    }
                    if (item.code === 'accident') {
                        state.checkStandardRouter = item.configItems.find(item => item.code === 'checkStandardRouter').value;
                    }
                }
                console.log('batterySystemInfoRenderData:', JSON.stringify(state.batterySystemInfoRenderData));
            }, {immediate: true, deep: true})
            
            return {
                state,
                getData
            }
        },
        components: {
            batterySystemInfo,
            batteryHealthy,
            // checkItemBattery
            // // checkPosition,
        }
    })
